<script setup lang="ts">
import { computed } from "vue";

import type { Discount } from "@Modules/billing/Data/Models/DiscountModel";
import useTranslation from "@Composables/useTranslation";

//
// Setup
const { __ } = useTranslation();

//
// Props
interface Props {
  discount?: Discount | null;
}

const props = withDefaults(defineProps<Props>(), {
  discount: null,
});

//
// Computed
/**
 * The sentence the banner reads, or an empty string when there is no discount to
 * announce or the coupon says nothing about how long it runs.
 */
const wording = computed<string>(() => {
  const discount = props.discount;

  if (discount === null) {
    return "";
  }

  const key = discount.wordingKey();

  if (key === "") {
    return "";
  }

  return __(key, { amount: discount.formattedAmount, months: discount.durationInMonths });
});

//
// Exposed Test Vars
defineExpose({ wording });
</script>

<template>
  <div
    v-if="wording !== ''"
    class="alert alert-success billing-discount _discount"
    role="status"
  >
    {{ wording }}
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;

.billing-discount {
  margin-bottom: spacing.$xxs;
}
</style>
